// view/stepthird.jsx
import React from 'react';
import { useState } from 'preact/hooks';
import { Row, Col, Alert, Calendar, Select } from 'antd';
import { TextCustom, TextHeadTitle } from '../../../components/text';
import { StyledContainerCalendar } from '../../../components/container/styled';
import { LOCALETH } from '../constant';
import { FORM_BOOKING_DETAIL, FORM_BOOKING_DETAIL_MAP } from '../forms/forms.js';
import { RenderForm } from './../../../components/forms/index';
import { GoogleMap, Marker, LoadScript, Autocomplete } from '@react-google-maps/api';
import { thaiDate, headerRender, disabledDate } from '../functions';
import moment from 'moment';
import 'moment/locale/th';
moment.locale('th');
import { color } from '../../../resources';
import { GUTTER_LAYOUT, BREAKE_POINT, MARGINTOP20 } from '../../../resources';
import { ModalTheme } from '../../../components/modal/index.jsx';
import { ButtonTheme } from '../../../components/buttons/index';
import { PDPA } from '../../../utils/pdpa/pdpa';
import { useMediaQuery } from 'react-responsive';

export const StepThird = ({ options, data, fn, forms, pdpa }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };

  const [showPDPAModal, setShowPDPAModal] = useState(false);
  const { consentStatus, toggleConsent, isConsentAccepted } = pdpa || {};
  const isPdpaAccepted = isConsentAccepted ? isConsentAccepted() : consentStatus === 'ACCEPTED';
  const showConsentError = !isPdpaAccepted;

  const { booking, branch, province, district, subDistrict, optionTime = [] } = options;
  const {
    isButtonAddressEnabled,
    bookingDate,
    bookingTime,
    bookingType,
    currentPosition,
    mapCenter,
  } = data;

  const {
    handleChangeField,
    handleDragEnd,
    onSelectDate,
    onSelectType,
    onSelectTime,
    onLoad,
    onPlaceChanged,
    onLoadAutocomplete,
  } = fn;

  const { control, setValue, getValues, errors } = forms;
  const googleMapKey = 'AIzaSyBb80hcSS7LxK7Jv2qrpgZSjEZX0UFf0N8';

  return (
    <div>
      <TextHeadTitle text={'นัดหมายวันเวลาและสถานที่ขาย'} bold />

      {/* เลือกประเภทการนัด (สาขา/นอกสถานที่) */}
      <div style={{ margin: '12px 0 20px 0' }}>
        {/** ปุ่มเลือกประเภท ถ้ามีในฟอร์มเดิมให้คง logic onSelectType ไว้ตามที่ index ส่งมา */}
        {/* ตัวเลือกรูปแบบเดิมของคุณอยู่ในฟอร์ม => RenderForm(FORM_BOOKING_DETAIL...) จะจัดการ field 'branch' ให้เอง */}
      </div>

      <Row gutter={GUTTER_LAYOUT?.OTHER_COUTENT}>
        {/* ซ้าย: เลือกวัน/เวลา */}
        <Col {...BREAKE_POINT?.MAIN_CONTENT}>
          <TextCustom text={'เลือกวันที่และเวลานัดหมาย'} size={'24px'} color={'#48BCB0'} />
          <div>
            <StyledContainerCalendar>
              <Calendar
                fullscreen={false}
                disabledDate={(current) => disabledDate(current, bookingType)}
                headerRender={headerRender}
                value={bookingDate}
                onSelect={onSelectDate}
                locale={{ lang: LOCALETH }}
              />
            </StyledContainerCalendar>
          </div>

          <br />
          {bookingDate && (
            <div className="space-container" style={{ margin: '20px 0px' }}>
              <span className="text-title">{'วันที่นัดหมาย'}</span>
              <span className="text-detail" style={{ color: color.theme }}>
                {thaiDate(moment(new Date(bookingDate)).format('YYYY-MM-DD'))}
              </span>
            </div>
          )}

          <div>
            <Alert
              description="หากต้องการขายด่วน รบกวนติดต่อแอดมิน LineOA: @applehouseth (มี@ด้านหน้า)"
              type="info"
              showIcon
              className="alert-info-red"
            />
          </div>

          <div style={{ ...MARGINTOP20 }}>
            <Select
              value={bookingTime || optionTime?.[0]?.value}
              style={{ width: '100%' }}
              onChange={(time) => onSelectTime(time)}
              options={optionTime}
            />
          </div>
        </Col>

        {/* ขวา: รายละเอียดการนัด + แผนที่กรณีนอกสถานที่ */}
        <Col {...BREAKE_POINT?.MAIN_CONTENT}>
          <TextCustom text={'รายละเอียดการนัดหมาย'} size={'24px'} color={'#48BCB0'} />

          {bookingType === 'BOOK-0001' && (
            <RenderForm
              control={control}
              forms={FORM_BOOKING_DETAIL({ optionsBranch: branch })}
              setValue={setValue}
              getValues={getValues}
            />
          )}

          {bookingType === 'BOOK-0002' && (
            <div>
              <div style={{ marginBottom: '20px' }}>
                <LoadScript googleMapsApiKey={googleMapKey} libraries={['places']}>
                  <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '400px' }}
                    center={mapCenter}
                    zoom={15}
                    onLoad={onLoad}
                  >
                    <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
                      <input type="text" placeholder="ค้นหาสถานที่" className="google-map-search" />
                    </Autocomplete>

                    {currentPosition.lat && currentPosition.lng && (
                      <Marker
                        position={currentPosition}
                        draggable={true}
                        onDragEnd={handleDragEnd}
                      />
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>

              <RenderForm
                control={control}
                forms={FORM_BOOKING_DETAIL_MAP({
                  options: { province, district, subDistrict },
                  isButtonAddressEnabled,
                })}
                setValue={setValue}
                getValues={getValues}
                errors={errors}
                onChange={handleChangeField}
              />
            </div>
          )}

          <Col style={{ marginLeft: '-12px' }}>
            <div style={{ margin: '12px 0' }}>
              <input
                id="consent-terms"
                type="checkbox"
                style={{ marginRight: '10px', transform: 'translateY(1px)' }}
                checked={isPdpaAccepted}
                onChange={(e) => toggleConsent && toggleConsent(e.target.checked)}
                aria-label="ยอมรับเงื่อนไขข้อตกลง"
              />
              <label
                htmlFor="consent-terms"
                style={{ fontSize: 'inherit', fontWeight: 400, color: '#111', cursor: 'pointer' }}
              >
                ฉันยอมรับ เงื่อนไขข้อตกลง{' '}
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowPDPAModal(true);
                  }}
                  className="custom-link"
                  aria-label="อ่านนโยบายความเป็นส่วนตัวแบบเต็ม"
                  style={{ background: 'none', border: 'none', padding: 0 }}
                >
                  นโยบายความเป็นส่วนตัว (Privacy Notice)
                </button>
              </label>
            </div>

            {/* Error Alert - Show until both consent checkboxes are accepted */}
            {showConsentError && (
              <Alert
                description="กรุณายอมรับเงื่อนไขข้อตกลงนโยบายความเป็นส่วนตัว"
                type="error"
                showIcon
                style={{ marginBottom: '12px' }}
                role="alert"
              />
            )}
          </Col>
        </Col>
      </Row>

      {/* PDPA Modal */}
      <ModalTheme
        destroyOnClose={true}
        title={null}
        open={showPDPAModal}
        onToggle={() => setShowPDPAModal(false)}
        width={1000}
        maskClosable={null}
        closable={true}
        keyboard={null}
        footer={[
          <ButtonTheme
            key="close"
            useFor="CONFIRM"
            onClick={() => setShowPDPAModal(false)}
            title="ปิด"
            disableIcon
            style={styledBtn}
          />,
        ]}
      >
        <>{PDPA}</>
      </ModalTheme>
    </div>
  );
};
